/**
 * Module Access Status Enum
 * Defines the possible states for module access control
 */
export enum ModuleStatus {
  ACTIVE = 'ACTIVE',
  HIDDEN = 'HIDDEN',
  COMING_SOON = 'COMING_SOON',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED'
}

/**
 * Module Keys Enum
 * Maps to backend field names for type-safe module access checks
 */
export enum ModuleKey {
  AI_ASSISTANT = 'aiAssistantStatus',
  CASH_POSITIONING = 'cashPositioningStatus',
  RECONCILIATION = 'reconciliationModuleAccessStatus',
  MERCHANT_RECONCILIATION = 'merchantReconciliationModuleAccessStatus',
  BOOK_RECONCILIATION = 'booKReconciliationModuleAccessStatus',
  OPEN_BANKING = 'openBankingModuleAccessStatus',
  PAYMENTS = 'paymentModuleAccessStatus',
  FORECASTING = 'forecastingModuleAccessStatus',
  MANUAL_BANK_STATEMENT = 'manualBankStatementStatus'
}
